module.exports = __webpack_public_path__ + "img/launcher_icon.cab76476.png";